<template>
  <div
    class="tw-flex tw-flex-col tw-max-w-full"
    :class="growClass"
    data-testid="adjustments-account-item"
  >
    <SfEllipsis
      class="tw-text-xs tw-leading-4 tw-text-sf-gray-darker"
      :length="360"
      :tooltip="label"
      :responsive-length="responsiveLength"
    >
      {{ label }}
    </SfEllipsis>
    <SfEllipsis
      class="tw-text-sm tw-leading-4 tw-text-sf-gray"
      :length="360"
      :tooltip="name"
      :responsive-length="responsiveLength"
    >
      {{ name }}
    </SfEllipsis>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'

import SfEllipsis from '@app/shared/vue/components/sf-ellipsis.vue'

interface Props {
  grow?: boolean
  label?: string | null
  name: string | null
}

const { label = null, grow = false } = defineProps<Props>()

const growClass = computed(() => {
  return grow ? 'tw-grow' : ''
})

const responsiveLength = {
  xl: 170,
  '2xl': 400,
}
</script>
